/**
 * Groups dashboard product items by the selected group-by option.
 * Unlike the favourites groupBy, products here are direct objects (not wrapped in productResponse).
 */
const getDashboardGroupKey = (item, groupBy) => {
	const keyMap = {
		REQUEST_PRIORITY: () => {
			const priority = item?.taskPriority;
			if (priority === 'HIGH') return 'High';
			if (priority === 'STANDARD') return 'Standard';
			if (priority === 'EXPRESS') return 'Express';
			return 'Others';
		},

		MARKET_AND_CATEGORY: () => {
			const market = item?.productGroup || 'No Market';
			const category = item?.name || 'No Category';
			return `${market} - ${category}`;
		},

		MARKET_AND_FABRIC: () => {
			const market = item?.productGroup || 'No Market';
			const fabric = item?.mainFabricType || 'No Fabric';
			return `${market} - ${fabric}`;
		},

		COLLECTION: () => {
			return item?.collectionName || 'No Collection';
		},

		///sample journey group by
		REQUEST_WISE: () => {
			const requestId =
				item?.inHouseDevelopmentJourneyDetails?.requestId ??
				item?.costingJourneyDetailsResponse?.requestId;
			const brandName =
				item?.inHouseDevelopmentJourneyDetails?.brandResponse?.name ??
				item?.costingJourneyDetailsResponse?.brandResponse?.name;
			const systemReferenceNumber =
				item?.systemReferenceNumber ?? item?.costingJourneyDetailsResponse?.systemReferenceNumber;
			const collectionName =
				item?.collectionName ?? item?.costingJourneyDetailsResponse?.collectionName;
			const requestTitle = [brandName, systemReferenceNumber, collectionName]
				.map((value) => (value != null ? String(value).trim() : ''))
				.filter(Boolean)
				.join(' | ');
			if (requestId != null && String(requestId).trim() !== '') {
				return requestTitle || 'No request';
			}
		}
	};

	return keyMap[groupBy] ? keyMap[groupBy]() : null;
};

export const dashboardGroupBy = (data, selectedGroupBy) => {
	if (!selectedGroupBy) return null;

	return data.reduce((acc, item) => {
		const key = getDashboardGroupKey(item, selectedGroupBy);
		if (key) {
			acc[key] = acc[key] || [];
			acc[key].push(item);
		}
		return acc;
	}, {});
};

export const Task_PRIORITY_OPTIONS = [
	{ id: 1, name: 'Standard', value: 'STANDARD' },
	{ id: 2, name: 'High', value: 'HIGH' },
	{ id: 3, name: 'Express', value: 'EXPRESS' }
];

export const formatDashboardDate = (value) => {
	if (!value) return '';

	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return value;

	const day = String(date.getDate()).padStart(2, '0');
	const month = date.toLocaleString('en-US', { month: 'short' });
	const year = String(date.getFullYear()).slice(-2);

	return `${day}-${month}-${year}`;
};

export const handleTextareaHeight = (e) => {
	e.target.style.height = 'auto';
	e.target.style.height = `${e.target.scrollHeight}px`;
};
